export default __webpack_public_path__ + "static/media/img-43-bayard.0609782f.jpg";